module.exports = __webpack_public_path__ + "static/img/appLogo.56522da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/appLogo.png
// module id = mEsS
// module chunks = 1